import { Box, Flex, VStack } from '@chakra-ui/layout';
import {
  Button,
  IconButton,
  Input,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  UseDisclosureProps,
} from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { getYearsDiff, isValidDate } from '@common/utility/datetime';
import React, { useMemo } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { DobSsnForm } from '.';
import { useSurveyBannerModel } from '../models/SurveyBannerModel';

type DateOfBirthProps = {
  form: UseFormReturn<DobSsnForm>;
  modalProps: UseDisclosureProps;
};

export const DateOfBirth: React.FC<DateOfBirthProps> = ({ form, modalProps }) => {
  const model = useSurveyBannerModel();
  const dob = form.watch('dob');

  const error = useMemo(() => {
    return form.formState.errors.dob?.message;
  }, [form.formState.errors.dob]);

  return (
    <ModalContent>
      <ModalHeader
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}
        borderBottomWidth={'1px'}
        borderBottomColor={'gray.300'}>
        <IconButton
          color="black"
          variant={'ghost'}
          aria-label="Back"
          icon={<Icon icon="chevron-left" />}
          onClick={() => model.prevStep()}
        />
        Birthdate
        <IconButton
          color="black"
          variant={'ghost'}
          aria-label="Back"
          icon={<Icon icon="times" />}
          onClick={modalProps.onClose}
        />
      </ModalHeader>
      <ModalBody>
        <Flex flex={1} p="24px" justifyContent={'space-between'} flexDirection={'column'} display={'flex'}>
          <VStack alignItems="flex-start" gap={'10px'} mb="100px">
            <Box w={'100%'}>
              <TextBlock textAlign="start" weight="bold" fontSize={'20px'} lineHeight={'20px'} mb="10px">
                Please enter your Birthdate.
              </TextBlock>
              <TextBlock fontSize={'14px'}>This is only used for regulatory requirements</TextBlock>
            </Box>
            <Input
              autoFocus
              onKeyUp={(e) => {
                if (e.key === 'Enter' && Boolean(dob)) {
                  model.nextStep();
                }
              }}
              size={'lg'}
              type="date"
              {...form.register('dob', {
                validate: (v) => {
                  if (!isValidDate(v) && new Date(v) < new Date()) return 'Birthday must be a valid date in the past';
                  if (getYearsDiff(new Date(v), new Date()) < 18)
                    return 'You must be at least 18 years old to continue';
                  return true;
                },
              })}
            />
            {error && (
              <TextBlock fontSize={12} color="red">
                {error}
              </TextBlock>
            )}
          </VStack>
        </Flex>
      </ModalBody>
      <ModalFooter>
        <Button
          autoFocus={true}
          isLoading={model.loading}
          isDisabled={!dob || Boolean(error)}
          w={'100%'}
          rightIcon={<Icon icon="chevron-right" />}
          mt={'10px'}
          onClick={() => model.nextStep()}>
          Continue
        </Button>
      </ModalFooter>
    </ModalContent>
  );
};
